<template>
  <div>
    <el-form
            ref="searchForm"
            :model="searchData"
            inline
    >
      <el-form-item label="ID">
        <el-input
                v-model.number="searchData.id"
                size="mini"
        />
      </el-form-item>

      <el-form-item label="类型">
        <el-select v-model="searchData.type" placeholder="请选择">
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="公司">
        <el-select v-model="searchData.company" placeholder="请选择">
          <el-option
                  v-for="item in companyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否可售">
        <el-select v-model="searchData.sellable" placeholder="请选择">
          <el-option
            v-for="item in sellable"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item>
        <el-button
                size="mini"
                @click="handlerSearch"
        >
          查找
        </el-button>
      </el-form-item>
    </el-form>


    <el-table :data="dataList"
              v-loading="loading"
              style="width: 100%"
              row-class-name="data-row-class">
      <el-table-column prop="id"
                       width="70px"
                       label="ID" />
      <el-table-column prop="type"
                       width="80px"
                       label="类型">
        <template slot-scope="scope">{{ type2Str(scope.row.type) }}</template>
      </el-table-column>
      <el-table-column label="保险公司">
        <template slot-scope="scope">
          {{(defines.insurance_company||{})[scope.row.data.company] || scope.row.data.company}}
        </template>
      </el-table-column>
      <el-table-column label="产品名">
        <template slot-scope="scope">
          {{ getProductName(scope.row.data.product_name) }}
        </template>
      </el-table-column>
      <el-table-column prop="data.contract_name"
                       label="保险产品名（合同中）" />
      <el-table-column label="最后修改">
        <template slot-scope="scope">
          {{scope.row.admin}}<br />{{scope.row.time}}
        </template>
      </el-table-column>
      <el-table-column label="标记">
        <template slot-scope="s">
          <label class="ai-label ai-label-success"
                 v-if="s.row.flag && s.row.flag.sellable">可售</label>
          <label class="ai-label ai-label-danger"
                 v-else>不可售</label>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="s">
          <el-button size="small"
                     @click="view(s.$index)">查看</el-button>
          <el-button size="small">
            <el-link :href="'#/product_management/edit/published/'+s.row.id"
                     type="primary"
                     target="_blank">编辑</el-link>
          </el-button>
          <el-button size="small"
                     @click="toggleSellable(s.$index)">{{s.row.flag && s.row.flag.sellable ? '停售' : '开售'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <page-bar :currentPageCount="dataList.length"
              @page-changed="loadData"></page-bar>

    <el-dialog title="产品详情"
               :visible.sync="showDetail"
               width="70%">
      <form-with-type :type="viewType"
                      :key="viewIndex"
                      :value="viewData"
                      check-required
                      disabled></form-with-type>
    </el-dialog>
  </div>
</template>
<script>
import request from '../../api/request'
import FormWithType from './FormWithType'
import PageBar from '../ui/PageBar';
import pm from '../../util/product_management'

export default {
  name: 'ProductManagementPublishedList',
  components: {
    FormWithType,
    PageBar
  },
  data() {
    return {
      loading: true,
      dataList: [],
      showDetail: false,
      viewIndex: 0,
      pageSize: 10,
      defines: {},
      searchData: {},
      filter: {},
      typeOptions: [{
        value: '',
        label: '请选择'
      },{
        value: 'term_life',
        label: '寿险'
      } , {
        value: 'critical_illness',
        label: '重疾险'
      }, {
        value: 'medical',
        label: '医疗险'
      }, {
        value: 'accident',
        label: '意外险'
      }, {
        value: 'annual',
        label: '年金险'
      }],
      companyOptionsHeard: [
        {
          value: '',
          label: '请选择'
        }
      ],
      companyOptions: [],
      sellable: [
        {
          value: '',
          label: '请选择'
        },
        {
          label: '可售',
          value: true,
        },
        {
          label: '不可售',
          value: false,
        }
      ],
    }
  },
  created() {
    this.loadData([0, 10])
    this.getCompanyOptions()
  },
  computed: {
    viewType() { return (this.dataList[this.viewIndex] || {}).type },
    viewData() { return (this.dataList[this.viewIndex] || {}) }
  },
  methods: {
    async loadData(range) {
      this.defines = await this.$store.dispatch('defines')
      request.product.post('product_get_list', { filter: this.filter, range: range }).then(r => {
        this.dataList = r.data.list
        this.loading = false
      })
    },
    view(index) {
      this.showDetail = true
      this.viewIndex = index
    },
    toggleSellable(index) {
      let p = this.dataList[index]
      let sellable = !(p.flag && p.flag.sellable)
      let text = ''
      if (sellable) {
        text = '确定要上架【' + p.data.contract_name + '】吗？'
      } else {
        text = '确定要下架【' + p.data.contract_name + '】吗？'
      }

      this.$confirm(text, '警告').then(() => {
        this.loading = true
        request.product.post('product_set_sellable', { id: p.id, sellable: sellable }).then(() => {
          this.loadData()
        }).catch(() => {
          this.loading = false
        })
      })
    },
    type2Str(t) {
      return pm.type2Str(t)
    },
    handlerSearch: function() {
      let filter = {}
      if (this.searchData.id) {
        filter.id = this.searchData.id
      }
      if (this.searchData.company) {
        filter.company = this.searchData.company
      }
      if (this.searchData.type) {
        filter.type = this.searchData.type
      }
      if (this.searchData.sellable !== '') {
        filter.sellable = this.searchData.sellable
      }

      console.log(filter)
      this.filter = filter
      this.loadData([0, 10]);
    },
    getCompanyOptions() {
      request.front.post('defines').then(r => {
        for (let k in r.data.insurance_company) {
          this.companyOptions.push({
            value: k,
            label: r.data.insurance_company[k]
          })
        }

        this.companyOptions.sort((l, r) => {
          return l.label.localeCompare(r.label, "zh");
        })

        this.companyOptions = this.companyOptionsHeard.concat(this.companyOptions)
      })
    },
    getProductName(name) {
      let tmp = '';
      for (let k in name) {
        tmp = tmp + name[k] + "|"
      }
      return tmp.slice(0, -1);
    },
  }
}
</script>
